$('.helen-account-parent').each(/** @this {Element} */ function () {
    let FirstCartItemAdded = false;

	const $main = $(this);
	$main.parent().css({'overflow': 'hidden'});
	const HelenAccountID = /** @type {string} */ ($main.attr('data-helen-account-id'));

	Ajax({
		'scope': $main,
		'url': '/helen/getaccount',
		'data': {
			'HelenAccountID': HelenAccountID,
            'Step': $main.attr('data-helen-account-step'),
            'Key': $_GET['k'],
		},
		'success': function (/** Object<string,?> */ data) {
            $main.html(data['content']);

            gtm(':helen.account.load');

            const $orders = $main.find('.helen-account-orders');
            const $quotes = $main.find('.helen-account-quotes');
            const $settings = $main.find('.helen-account-settings');

            const $helen = $main.closest('.helen');
            const $parent = $main.find('.helen-account-form-parent');

            const /** !Object<string,string> */ p = {
                'DETAILS': 'details',
                'ORDERS': 'orders',
                'PROOFS': 'proofs',
                'QUOTES': 'quotes',
                'SHIPPING': 'shipping',
                'BILLING': 'billing',
                'SETTINGS': 'settings',
            };

            const $doc = $(document);

            const logoutButton = document.getElementById("helen-account-logout");

            logoutButton.addEventListener('click', function () {
                Ajax({
                    url: '/helen/logout',
                    data: {
                        'domain': document.domain,
                    },
                    method: 'post',
                    success: function () {
                        window.location.href = '/';
                    }
                })
            });

			/**
			 * @param {string} s
			 */
			const Step = function (s) {
                $parent.removeClass(Object.values(p).map(v => 'helen-account-form-parent-'+v).join(' '));

                switch (s) {
                case p['ORDERS']:
                    Ajax({
                        url: '/helen/account/orders',
                        data: {
                            'HelenAccountID': HelenAccountID,
                        },
                        success: function (/** Object<string,*> */ d) {
                            $orders.html(/** @type {string} */ (d['content']));

                                                        /**
                             * @param {number} n
                             * @param {string} cart
                             * @param {string} total
                             * @param {string} shipping
                             */
                            const success = function (n, cart) {
                                if (n !== 0) {
                                    $helen.find('.helen-cart-count').text(n);
                                    // $CheckoutButton.removeClass('d-none');
                                }// else {
                                    // $CheckoutButton.addClass('d-none');
                                // }
                                $main.find('.helen-account-cart-items-parent').html(cart);
                                // $cart.find('.helen-checkout-cart-total').text(total);
                                // CartTotal = total;
                                // CartShipping = shipping;
                                // UpdateTotals();
                            };
                            $orders.find('.helen-account-order-to-cart-button').on('click', /** @this {Element} */ function () {
                                const $this = $(this);
                                const $q = $this.closest('.helen-account-order');
                                $q.addClass('active');

                                AddOrderToCart(/** @type {string} */ ($q.attr('data-order-id')),
                                    /**
                                     * @param {number} n
                                     * @param {string} cart
                                     * @param {string} total
                                     * @param {string} shipping
                                     */
                                    function (n, cart, total, shipping) {
                                    // if (!FirstCartItemAdded) {
                                    //     FirstCartItemAdded = true;
                                    //     Dialog({
                                    //         title: "Order added to your cart!",
                                    //         text: "Want to add anything else to your cart? You can checkout anytime by clicking the 'Cart' button on the left.",
                                    //         type: 'success',
                                    //         confirm: 'Go to cart',
                                    //         cancel: 'Stay in account settings',
                                    //         success: function () {
                                    //             // $CheckoutButton.trigger('click');
                                    //             window.location = '/cart';
                                    //         }
                                    //     });
                                    // }
                                    window.location = '/cart';

                                    success(n, cart, total, shipping);
                                });
                            });

                            // $orders.find('.helen-account-remove-order-from-cart-button').on('click', /** @this {Element} */ function () {
                            //     const $this = $(this);
                            //     const $q = $this.closest('.helen-account-quote');
                            //     $q.removeClass('active');

                            //     DeleteOrderFromCart(/** @type {string} */ ($q.attr('data-quote-id')), success);
                            // });
                        }
                    });
                case p['QUOTES']:
                    Ajax({
                        url: '/helen/account/quotes',
                        data: {
                            'HelenAccountID': HelenAccountID,
                        },
                        success: function (/** Object<string,*> */ d) {
                            $quotes.html(/** @type {string} */ (d['content']));

                            /**
                             * @param {number} n
                             * @param {string} cart
                             * @param {string} total
                             * @param {string} shipping
                             */
                            const success = function (n, cart) {
                                if (n !== 0) {
                                    $helen.find('.helen-cart-count').text(n);
                                    // $CheckoutButton.removeClass('d-none');
                                }// else {
                                    // $CheckoutButton.addClass('d-none');
                                // }
                                $main.find('.helen-account-cart-items-parent').html(cart);
                                // $cart.find('.helen-checkout-cart-total').text(total);
                                // CartTotal = total;
                                // CartShipping = shipping;
                                // UpdateTotals();
                            };
                            $quotes.find('.helen-account-quote-select-button').on('click', /** @this {Element} */ function () {
                                const $this = $(this);
                                const $q = $this.closest('.helen-account-quote');
                                $q.addClass('active');

                                AddQuoteToCart(/** @type {string} */ ($q.attr('data-quote-id')),
                                    /**
                                     * @param {number} n
                                     * @param {string} cart
                                     * @param {string} total
                                     * @param {string} shipping
                                     */
                                    function (n, cart, total, shipping) {
                                    if (!FirstCartItemAdded) {
                                        FirstCartItemAdded = true;
                                        Dialog({
                                            title: "Quote added to your cart!",
                                            text: "Want to add anything else to your cart? You can checkout anytime by clicking the 'Cart' button on the left.",
                                            type: 'success',
                                            confirm: 'Go to cart',
                                            cancel: 'Stay in account settings',
                                            success: function () {
                                                // $CheckoutButton.trigger('click');
                                                window.location = '/cart';
                                            }
                                        });
                                    }

                                    success(n, cart, total, shipping);
                                });
                            });

                            $quotes.find('.helen-account-quote-deselect-button').on('click', /** @this {Element} */ function () {
                                const $this = $(this);
                                const $q = $this.closest('.helen-account-quote');
                                $q.removeClass('active');

                                DeleteQuoteFromCart(/** @type {string} */ ($q.attr('data-quote-id')), success);
                            });

                            $quotes.find('.helen-account-quote-show-breakdown-link,.helen-account-quote-hide-breakdown-link').on('click', /** @this {Element} */ function (/** Event */ e) {
                                e.preventDefault();
                                e.stopPropagation();

                                const $this = $(this);

                                $this.closest('.helen-account-quote').toggleClass('helen-account-quote-breakdown-visible');
                                setTimeout(function () {
                                    $this.closest('.helen-account-quote').find('.helen-account-quote-main').trigger('height:check')
                                }, 200);
                            });

                            $quotes.find('.helen-account-quote').on('click', /** @this {Element} */ function (/** Element */ e) {
                                if (get_selected_text() === '' && !$(e['target']).is('a,button,img')) {
                                    $(this).find('.helen-account-quote-show-breakdown-link').trigger('click');
                                }
                            });

                            $quotes.find('.helen-account-quote-share-link').on('click', /** @this {Element} */ function (/** Event */ e) {
                                e.preventDefault();
                                e.stopPropagation();
                                const $this = $(this);
                                const $q = $this.closest('.helen-account-quote');

                                Dialog({
                                    title: 'Share a link to your quote',
                                    input: 'text',
                                    inputValue: window.location.protocol + '//' + window.location.host + '/myquote?id=' + encodeURIComponent(/** @type {string} */ ($q.attr('data-quote-hash'))),
                                    continue: 'Close'
                                });
                                const $i = $(swal.getInput()).attr({'readonly': true}).on('focus', /** @this {Element} */ function () {
                                    $(this).trigger('select');
                                });
                                setTimeout(function () {
                                    $i.trigger('focus');
                                });
                            });
                        }
                    });
                }

                $parent.addClass('helen-account-form-parent-'+s);
                $doc.trigger(':helen.account.'+s);
                window.location.hash = "#"+s;

                $helen.find('.nav-item.active').removeClass('active');
                $helen.find('.nav-link.helen-account-'+s+'-link').parent().addClass('active');
            }

            for (const k in p) {
                if ($parent.hasClass('helen-account-form-parent-'+p[k])) {
                    Step(p[k]);
                    break;
                }
            }

			let /** string */ hash = window.location.hash;
			const CheckHash = setInterval(function () {
				if (window.location.hash !== hash) {
					hash = window.location.hash;
					if (hash === '#end') {
						clearInterval(CheckHash);
						return;
					}
                    for (const k in p) {
                        if (hash === '#'+p[k]) {
                            Step(p[k]);
                            break;
                        }
                    }
				}
            }, 100);

            for (const /** string */ k in p) {
                $helen.find('.helen-account-'+p[k]+'-link').on('click', /** @this {Element} */ function (/** Event */ e) {
                    e.preventDefault();

                    Step(p[k]);
                });
            }

            $main.find('input[type="tel"]').each(/** @this {Element} */ function () {
				const $this = $(this);
				$this.data('iti', intlTelInput(this, {
					'dropdownContainer': document.body,
					'separateDialCode': true,
					'autoPlaceholder': 'aggressive',
					'utilsScript': 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.min.js',
					'customPlaceholder': function (/** string */ selectedCountryPlaceholder, _) {
						return "e.g. " + selectedCountryPlaceholder;
					},
				}));
				setTimeout(function () {
					$this.attr('autocomplete', 'tel-national');
				});
			});

			const $Phone = $settings.find('.helen-account-phone-input');
            let PhoneIti = /** @type {!iti} */ ($Phone.data('iti'));

            $settings.find('.helen-account-form').on('submit', function (/** Event */ e) {
                e.preventDefault();

                const $Controls = $settings.find('input,select,button,a,textarea');
                const l = Ladda.create($settings.find('.helen-account-update-button')[0]);
                l.start();
                $Controls.attr('disabled', true);

                Ajax({
                    scope: $settings,
                    url: '/helen/account/updatesettings',
                    data: {
                        'HelenAccountID': HelenAccountID,
                        'FirstName': $settings.find('.helen-account-first-name-input').val(),
                        'LastName': $settings.find('.helen-account-last-name-input').val(),
                        'Company': $settings.find('.helen-account-company-input').val(),
                        'Phone': PhoneIti.getNumber(),
                        '_Phone': $settings.find('.helen-account-phone-input').val(),
                        'OldPassword': $settings.find('.helen-account-old-password-input').val(),
                        'NewPassword': $settings.find('.helen-account-new-password-input').val(),
                        'ConfirmPassword': $settings.find('.helen-account-confirm-password-input').val(),
                        'UserRoleOptionID': $settings.find('.helen-account-user-role-option-select').val(),
                        'SMS': $settings.find('.helen-account-sms-checkbox').is(':checked'),
                    },
                    success: function () {
                        Dialog({
                            title: 'Success!',
                            text: 'Your changes have been saved.',
                            type: 'success'
                        });

                        $settings.find('.helen-account-old-password-input,.helen-account-new-password-input,.helen-account-confirm-password-input').val('');

                        gtm(':helen.account.updatesettings.success');
                    },
                    complete: function () {
                        l.stop();
                        $Controls.attr('disabled', false);
                    },
                    error: function () {
                        gtm(':helen.account.updatesettings.error');
                    },
                });
            });

        },
        defaultError: false,
        error: function () {
            window.location = '/login';
        },
	});

});